import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { OrganizationAdminRoutingModule } from './organization-admin-routing.module';

import { OrganizationAdminComponent } from './organization-admin.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrgDetailsComponent } from './components/org-details/org-details.component';
import { OrgViewComponent } from './components/org-view/org-view.component';
import { OrgCreateComponent } from './components/org-create/org-create.component';



@NgModule({
  declarations: [
    OrganizationAdminComponent, 
    DashboardComponent, OrgDetailsComponent, OrgViewComponent, OrgCreateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    OrganizationAdminRoutingModule
  ]
})
export class OrganizationAdminModule { }
